import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';

const QuestionObserver = ({
  className,
  children,
  questionIndex,
  onActiveChange,
}) => {
  const prevTopRef = useRef(null);

  const handleViewChange = (isInView, currentEntry) => {
    if (!currentEntry) return;

    const currentTop = currentEntry.boundingClientRect.top;
    let scrollDown = true;

    if (prevTopRef.current !== null) {
      scrollDown = currentTop < prevTopRef.current;
    }

    prevTopRef.current = currentTop;

    if (isInView) {
      if (scrollDown) {
        onActiveChange(questionIndex);
      }
    }

    if (!isInView && !scrollDown) {
      onActiveChange(questionIndex - 1);
    }
  };

  const { ref } = useInView({
    threshold: 0,
    rootMargin: '-105px 0px 0px 0px',
    onChange: handleViewChange,
  });

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};

QuestionObserver.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  questionIndex: PropTypes.number.isRequired,
  onActiveChange: PropTypes.func.isRequired,
};

export default QuestionObserver;
